// extracted by mini-css-extract-plugin
export default {"title__content":"title_title__content__23Xdp","title__text":"title_title__text__2I++i"};